<p-panel class="secondary-panel">
  <ng-template pTemplate="header">Seller Details</ng-template>

  <cmg-info-panel-content>
    <div class="row">
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Seller Name" [value]="loan1008Data?.seller.company | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 ps-md-4">
        <cmg-info-row
          label="Seller Address"
          [value]="sellerAddress(loan1008Data?.seller.street, loan1008Data?.seller.city, loan1008Data?.seller.state, loan1008Data?.seller.zip)"
        />
      </div>
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Seller City" [value]="loan1008Data?.seller.city | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 ps-md-4">
        <cmg-info-row label="Seller State" [value]="loan1008Data?.seller.state | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Zip Code" [value]="loan1008Data?.seller.zip | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 ps-md-4">
        <cmg-info-row label="Seller No" [value]="loan1008Data?.transmittal.sellerNo | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Seller Loan No" [value]="loan1008Data?.transmittal.sellerLoanNo | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 ps-md-4">
        <cmg-info-row label="Investor Loan No" [value]="loan1008Data?.transmittal.investorLoanNo | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Contact Name" [value]="loan1008Data?.seller.partyName | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 ps-md-4">
        <cmg-info-row label="Contact Title" [value]="loan1008Data?.seller.title | emptyToDash" />
      </div>
      <div class="col-12 col-md-6 border-md-end">
        <cmg-info-row label="Contact's Phone No" [value]="loan1008Data?.seller.phone | phoneNumber | emptyToDash" />
      </div>
    </div>
  </cmg-info-panel-content>
</p-panel>
